import { Route, Router } from "@angular/router";

import { pmoEntity } from "../../core/guards";
import { isDsV3 } from "../../core/utils";
import { SubmenuComponent } from "../../shared/components/console/submenu/submenu";
import { Constants } from "../../shared/constants/constants";
import { PageMode } from "../../shared/constants/enums";
import {
  createTPCyclesPageGuards,
  createTransformationalProjectsPageGuards,
  createTTargetsPageGuards,
  isExternalOrDs2,
  manageTPCyclesPageGuards,
  manageTPMilestonePageGuards,
  manageTransformationalProjectsPageGuards,
  manageTTargetsPageGuards,
  viewAgreementPageGuards,
  viewTPCyclesPageGuards,
  viewTPDashboardPageGuards,
  viewTPMilestonePageGuards,
  viewTPSubMenu,
  viewTransformationalProjectsPageGuards,
  viewTTargetsPageGuards,
} from "./_guards";

export const TP_DASHBOARD_ROUTES: Route[] = [
  {
    path: "national-projects-dashboard",
    children: [
      {
        path: "",
        loadComponent: () => import("./dashboard/tp-dashboard/tp-dashboard").then((e) => e.TpDashboardComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.dashboard",
          breadcrumb: "national_projects.dashboard",
        },
      },
      {
        path: "projects",
        children: [
          {
            path: "",
            loadComponent: () =>
              import("./dashboard/tp-cards-dashboard/tp-cards-dashboard").then((e) => e.TpCardsDashboardComponent),
            canActivate: [...viewTPDashboardPageGuards],
            data: {
              title: "national_projects.project_names",
              breadcrumb: "national_projects.project_names",
            },
          },
          {
            path: ":id",
            loadComponent: () => import("./transformational-project/tp-view/tp-view").then((e) => e.TpViewComponent),
            canActivate: [...viewTransformationalProjectsPageGuards],
            data: {
              title: "national_projects.view_national_project",
              breadcrumb: "national_projects.view_national_project",
            },
          },
        ],
      },
      {
        path: "owners",
        loadComponent: () =>
          import("./dashboard/tp-cards-dashboard/tp-cards-dashboard").then((e) => e.TpCardsDashboardComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.project_names",
          breadcrumb: "national_projects.project_names",
        },
      },
      {
        path: "main-sectors/:id",
        loadComponent: () =>
          import("./dashboard/tp-cards-dashboard/tp-cards-dashboard").then((e) => e.TpCardsDashboardComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.project_names",
          breadcrumb: "national_projects.project_names",
        },
      },
      {
        path: "sectors/:id",
        loadComponent: () =>
          import("./dashboard/tp-cards-dashboard/tp-cards-dashboard").then((e) => e.TpCardsDashboardComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.project_names",
          breadcrumb: "national_projects.project_names",
        },
      },
      {
        path: "milestones/:id",
        loadComponent: () => import("./milestones/milestone-view/milestone-view").then((e) => e.MilestoneViewComponent),
        canActivate: [...viewTPMilestonePageGuards],
        data: {
          title: "national_projects.national_projects_milestone.singular_title",
          breadcrumb: "national_projects.national_projects_milestone.singular_title",
        },
      },
      {
        path: "progerss-comparison",
        loadComponent: () => import("./dashboard/tp-progerss/tp-progerss").then((e) => e.TpProgerssComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.overall_projects",
          breadcrumb: "national_projects.overall_projects",
          filterBy: "progerss",
        },
      },
      {
        path: "achievement-comparison",
        loadComponent: () => import("./dashboard/tp-progerss/tp-progerss").then((e) => e.TpProgerssComponent),
        canActivate: [...viewTPDashboardPageGuards],
        data: {
          title: "national_projects.overall_achievement",
          breadcrumb: "national_projects.overall_achievement",
          filterBy: "achievement",
        },
      },
    ],
  },
];

const TP_PAGES_ROUTES: Route[] = [
  {
    path: "national-projects",
    canActivate: [...viewTransformationalProjectsPageGuards],
    children: [
      {
        path: "",
        loadComponent: () => import("./transformational-project/tp-list/tp-list").then((e) => e.TpListComponent),
        data: {
          breadcrumb: "national_projects.console_title",
          title: "national_projects.console_title",
        },
      },
      {
        path: "create",
        loadComponent: () => import("./transformational-project/tp-editor/tp-editor").then((e) => e.TpEditorComponent),
        canActivate: [...createTransformationalProjectsPageGuards],
        data: {
          breadcrumb: "national_projects.create_project",
          title: "national_projects.create_project",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () => import("./transformational-project/tp-editor/tp-editor").then((e) => e.TpEditorComponent),
        canActivate: [...manageTransformationalProjectsPageGuards],
        data: {
          breadcrumb: "national_projects.edit_project",
          title: "national_projects.edit_project",
          pageMode: PageMode.edit,
        },
      },
    ],
  },
];

const TP_MILESTONE_PAGES_ROUTES: Route[] = [
  {
    path: "project-milestones",
    canActivate: [...viewTPMilestonePageGuards],
    children: [
      {
        path: "",
        loadComponent: () => import("./milestones/milestone-list/milestone-list").then((e) => e.MilestoneListComponent),
        data: {
          breadcrumb: "national_projects.national_projects_milestone.title",
          title: "national_projects.national_projects_milestone.title",
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./milestones/milestone-editor/milestone-editor").then((e) => e.MilestoneEditorComponent),
        canActivate: [...manageTPMilestonePageGuards],
        data: {
          breadcrumb: "national_projects.national_projects_milestone.singular_title",
          title: "national_projects.national_projects_milestone.singular_title",
        },
      },
    ],
  },
];

const CYCLES_ROUTES: Route[] = [
  {
    path: "cycles",
    canActivate: [pmoEntity, ...viewTPCyclesPageGuards],
    children: [
      {
        path: "",
        loadComponent: () => import("./cycles/tp-cycles-list/tp-cycles-list").then((e) => e.TpCyclesListComponent),
      },
      {
        path: "create",
        loadComponent: () => import("./cycles/tp-cycle-editor/tp-cycle-editor").then((e) => e.TpCycleEditorComponent),
        canActivate: [...createTPCyclesPageGuards],
        data: {
          breadcrumb: "national_projects.cycles.create_tp_cycle",
          title: "national_projects.cycles.create_tp_cycle",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () => import("./cycles/tp-cycle-editor/tp-cycle-editor").then((e) => e.TpCycleEditorComponent),
        canActivate: [...manageTPCyclesPageGuards],
        data: {
          breadcrumb: "national_projects.cycles.edit_tp_cycle",
          title: "national_projects.cycles.edit_tp_cycle",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () => import("./cycles/tp-cycle-editor/tp-cycle-editor").then((e) => e.TpCycleEditorComponent),
        canActivate: [...viewTPCyclesPageGuards],
        data: {
          breadcrumb: "national_projects.cycles.view_tp_cycle",
          title: "national_projects.cycles.view_tp_cycle",
          pageMode: PageMode.view,
        },
      },
    ],
    data: {
      breadcrumb: "national_projects.cycles.tp_cycles",
      title: "national_projects.cycles.tp_cycles",
    },
  },
];

const SECTORS_ROUTES: Route[] = [
  {
    path: "sectors",
    canActivate: [pmoEntity],
    children: [
      {
        path: "",
        loadComponent: () => import("./sectors/tp-sectors-list/tp-sectors-list").then((e) => e.TpSectorsListComponent),
        canActivate: [...viewTransformationalProjectsPageGuards],
      },
      {
        path: "create",
        loadComponent: () =>
          import("./sectors/tp-sectors-editor/tp-sectors-editor").then((e) => e.TpSectorsEditorComponent),
        canActivate: [...createTransformationalProjectsPageGuards],
        data: {
          breadcrumb: "national_projects.national_sector.editor.create",
          title: "national_projects.national_sector.editor.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./sectors/tp-sectors-editor/tp-sectors-editor").then((e) => e.TpSectorsEditorComponent),
        canActivate: [...manageTransformationalProjectsPageGuards],
        data: {
          breadcrumb: "national_projects.national_sector.editor.edit",
          title: "national_projects.national_sector.editor.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () =>
          import("./sectors/tp-sectors-editor/tp-sectors-editor").then((e) => e.TpSectorsEditorComponent),
        canActivate: [...viewTransformationalProjectsPageGuards],
        data: {
          breadcrumb: "national_projects.national_sector.editor.view",
          title: "national_projects.national_sector.editor.view",
          pageMode: PageMode.view,
        },
      },
    ],
    data: {
      breadcrumb: "national_projects.national_sector.title",
      title: "national_projects.national_sector.title",
    },
  },
];

const TARGETS_ROUTES: Route[] = [
  {
    path: "transformational-targets",
    canActivate: [pmoEntity, ...viewTTargetsPageGuards],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./transformational-targets/transformational-targets-list/transformational-targets-list").then(
            (e) => e.TransformationalTargetsListComponent
          ),
        data: {
          tableConfList: Constants.MAIN_TABLE_LIST_CONF_KEY.TRANSFORMATIONAL_TARGETS,
        },
      },
      {
        path: "create",
        loadComponent: () =>
          import("./transformational-targets/transformational-target-editor/transformational-target-editor").then(
            (e) => e.TransformationalTargetEditorComponent
          ),
        canActivate: [...createTTargetsPageGuards],
        data: {
          breadcrumb: "national_projects.transformational_targets.create_transformational_target",
          title: "national_projects.transformational_targets.create_transformational_target",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./transformational-targets/transformational-target-editor/transformational-target-editor").then(
            (e) => e.TransformationalTargetEditorComponent
          ),
        canActivate: [...manageTTargetsPageGuards],
        data: {
          breadcrumb: "national_projects.transformational_targets.edit_transformational_target",
          title: "national_projects.transformational_targets.edit_transformational_target",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () =>
          import("./transformational-targets/transformational-target-view/transformational-target-view").then(
            (e) => e.TransformationalTargetViewComponent
          ),
        canActivate: [...viewTTargetsPageGuards],
        data: {
          breadcrumb: "national_projects.transformational_targets.view_transformational_target",
          title: "national_projects.transformational_targets.view_transformational_target",
        },
      },
    ],
    data: {
      breadcrumb: "national_projects.transformational_targets.title",
      title: "national_projects.transformational_targets.title",
    },
  },
];

const AGREEMENTS_ROUTES: Route[] = [
  {
    path: "agreements",
    canActivate: [...viewAgreementPageGuards],
    children: [
      {
        path: "",
        loadComponent: () => import("./agreements/agreements").then((e) => e.AgreementsComponent),
        data: {
          breadcrumb: "national_projects.agreements.title",
          title: "national_projects.agreements.title",
        },
      },
    ],
  },
];

export const TP_ROUTES: Route[] = [
  {
    path: "national-project",
    canActivate: [isExternalOrDs2, ...viewTPSubMenu],
    data: {
      breadcrumb: "breadcrumbs.transformational_project",
    },
    children: [
      {
        path: "",
        component: SubmenuComponent,
        data: {
          onCycleChange: (router: Router) => router.navigateByUrl(isDsV3() ? "console" : "console/national-project"),
        },
      },
      ...TP_PAGES_ROUTES,
      ...TP_MILESTONE_PAGES_ROUTES,
      ...CYCLES_ROUTES,
      ...SECTORS_ROUTES,
      ...TARGETS_ROUTES,
      ...AGREEMENTS_ROUTES,
    ],
  },
];
